// Anchors the mobile search bar to the header's bottom edge (SM-738).
//
// Desktop search pops out as a floating bar below the header over a darkened
// page. On mobile, snippets/search-modal.liquid pins the dialog with
// `inset-block: var(--search-modal-offset, 0px) auto`, and this sets that
// offset when the dialog opens, so the bar sits under the header rather than
// covering it.
//
// The header's bottom edge moves with scroll — the announcement bar sits above
// it at the top of the page, and only the sticky header remains once scrolled
// — so it is measured at open time rather than derived from --header-height.
// The search trigger lives in the header, so the header is on screen whenever
// the dialog opens. `dialog:open` fires in the same frame as showModal(),
// before paint, so the bar never flashes at the top first.

const MOBILE = window.matchMedia('(max-width: 749px)');

const modal = document.getElementById('search-modal');

modal?.addEventListener('dialog:open', () => {
  const dialog = modal.querySelector('dialog');
  if (!(dialog instanceof HTMLDialogElement)) return;

  const header = document.querySelector('header-component');
  const offset = MOBILE.matches && header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
  dialog.style.setProperty('--search-modal-offset', `${offset}px`);
});
